<span class="lot-status-tag" [ngClass]="'lot-status-tag--' + status.variant" [class.lot-status-tag--large]="large">
  {{ status.label }}
</span>
